/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'lock': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M5.345 1.5h5.31a.5.5 0 01.5.5v4.857h-6.31V2a.5.5 0 01.5-.5zm-2 5.357V2a2 2 0 012-2h5.31a2 2 0 012 2v4.857h.163a1 1 0 011 1V15a1 1 0 01-1 1H3.182a1 1 0 01-1-1V7.857a1 1 0 011-1h.163z" _fill="#B1ADC2"/><ellipse pid="1" cx="8" cy="10.727" rx="1.072" ry="1.052" transform="rotate(-180 8 10.727)" _fill="#fff"/><rect pid="2" x="8.538" y="13.182" width="1.077" height="2.806" rx=".538" transform="rotate(-180 8.538 13.182)" _fill="#fff"/>'
  }
})
